/**
 * POS Take picture controller
 *
 * Used on the POS to allow user to take photo from the webcam
 **/

app.controller('WebcamCtrl', function($scope, $window, $attrs, WebcamService) {
    $scope.video      = null;
    $scope.canvas     = null;
    $scope.showWebcam = false;

    $scope.toggleWebcam = function() {
        $scope.showWebcam = !$scope.showWebcam;
        if ($scope.showWebcam)
            $scope.initCamera();
        else {
            $scope.video.pause();
            $scope.video.currentTime = 0;
            WebcamService.clearphoto($scope.canvas);
        }
    };

    $scope.initCamera = function() {
        $scope.video  = angular.element('#video')[0];
        $scope.canvas = angular.element('#canvas')[0];

        WebcamService.startup($scope.video, $scope.canvas, /*width*/$attrs.passPhotoWidth, /*streaming*/false);
    };

    $scope.takePicture = function() {
        var dataUrl = WebcamService.takepicture($scope.canvas);
        if ($scope.$parent && typeof $scope.$parent.handleWebcamPicture === 'function')
            $scope.$parent.handleWebcamPicture(dataUrl);

        window.dispatchEvent(new CustomEvent('webcam-captured', {
            bubbles: true,
            detail: { dataUrl: dataUrl }
        }));

        $scope.toggleWebcam();
    };
});
